import moment from "moment"
import "moment/locale/de"

moment.locale("de")

export const isNowOrInFuture = (time_limit: string) =>
  moment().isSameOrBefore(moment.parseZone(time_limit, "DD.MM.YYYY"), "day")


export const momentDependend = (
  time_limit: string,
  sameOrBeforeText: string,
  afterText: string
): string =>
  isNowOrInFuture(time_limit)
  ? sameOrBeforeText
  : afterText

export const fmtDate = (date: string): string =>
  moment.parseZone(date, "DD.MM.YYYY").format("D. MMMM YYYY")
